/**
 * ChartContainer —— ECharts 包装 (Phase 5-1 共享组件)
 *
 * 设计意图：
 *  - 把 echarts-for-react 封一层，提供统一的 loading / 空状态 / 高度 props；
 *  - 避免 page 端直接 import echarts-for-react，便于未来切到 lazy load
 *    或换底层图表库（mark v1.1 candidate）。
 *
 * Props:
 *  - option: ECharts option 对象（caller 直接传 echarts 标准 option）
 *  - height: 图高（默认 320）
 *  - loading: 显示 loading 覆盖层
 *  - title: 顶部标题（可选）
 *  - empty: 是否为空（caller 自己判断，传 boolean）
 *
 * 注意：测试环境 (jsdom) echarts canvas API 不全；测试时只验证 testid + props，
 * 不实际渲染图。
 */
import ReactECharts from 'echarts-for-react';
import { Card, Empty, Spin } from 'antd';

export interface ChartContainerProps {
  option: Record<string, unknown>;
  height?: number;
  loading?: boolean;
  title?: string;
  empty?: boolean;
  testId?: string;
}

export function ChartContainer({
  option,
  height = 320,
  loading = false,
  title,
  empty = false,
  testId,
}: ChartContainerProps) {
  return (
    <Card
      title={title}
      size="small"
      data-testid={testId ?? 'dashboard-chart'}
      styles={{ body: { padding: 8 } }}
    >
      {loading ? (
        <div
          style={{
            height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          data-testid={`${testId ?? 'dashboard-chart'}-loading`}
        >
          <Spin />
        </div>
      ) : empty ? (
        <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Empty description="暂无数据" data-testid={`${testId ?? 'dashboard-chart'}-empty`} />
        </div>
      ) : (
        <ReactECharts
          option={option}
          style={{ height, width: '100%' }}
          notMerge
          lazyUpdate
          data-testid={`${testId ?? 'dashboard-chart'}-echarts`}
        />
      )}
    </Card>
  );
}
